import { connect } from 'react-redux';
import { updateTransaction } from '../../../../redux/modules/transaction';
import ConfirmDetails from './ConfirmDetails';

export default connect(null, {
  updateTransaction,
})(ConfirmDetails);
